module.exports = __webpack_public_path__ + "static/media/payments.c553a8b0.svg";